import React, { useState } from 'react'

const QRSignupFormRaffle = ({page, handleNextPage, sendLotteryResult}) => {

     const [formData, setFormData] = useState({
        lottery: true,
        lotteryResult: ''
      });

        const [errors, setErrors] = useState({});
        const [buttonColor, setButtonColor] = useState(false)


      const validate = () => {
        const newErrors = {};
        
        if (formData.lottery && formData.lotteryResult === '') newErrors.lottery = "Please click on Spin";
          
        return newErrors;
      };

      const handleSubmit = () => {
        const validationErrors = validate();
        // console.log(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
        } else {
          setButtonColor(true)

          sendLotteryResult(formData.lotteryResult)
          handleNextPage()

          setButtonColor(false) 
        }
      };

      const [isSpinning, setIsSpinning] = useState(false);
      const [showMessage, setShowMessage] = useState(false);
      const [isBlurred, setIsBlurred] = useState(false);

      function spinTheWheel(){
        setIsSpinning(true);
        setIsBlurred(false);
        setShowMessage(false)

        let lotRes = ''
        let num = Math.random().toFixed(2)

        // console.log(num);
        
         
			// if(num >= 0.1 && num <= 0.2){
			//  lotRes = 'Water Bottle'
			// }
			// else 
			if(num > 0.1 && num <= 0.3){
              lotRes = 'T-Shirt'
			}
				else if(num > 0.3 && num <= 0.48){
					lotRes = 'Bag'
				}
				else if(num > 0.48 && num <= 0.62){
					lotRes = 'Pen'
				}
            else if(num > 0.8 && num <= 0.9){
              lotRes = 'Mousepad'
            }
            else if(num > 0.9 && num <= 1.0){
				lotRes = 'T-Shirt'  // Hat
            }
            else{
				lotRes = 'Post-It Notes'  // 'Bag or Post-It Notes or Pen'
            }
       

        // console.log("RESULT: ",lotRes);
        setFormData({...formData, lotteryResult: lotRes})
        
        setTimeout(() => {
          setIsBlurred(true);
          setShowMessage(true)
        },2500)

        setTimeout(() => {
          setIsSpinning(false);
        }, 3000); // 3 seconds
      }


  return (
    <div className='flex flex-col items-center'>
            <p className='mt-4 text-3xl text-[var(--color-primary-purple)] font-bold text-center'>Welcome to ACGT</p>
            
            <div className='mt-4 w-full px-4 sm:p-8 flex flex-col justify-center items-center max-w-[800px]'>
                <div className='w-full sm:w-[90%] xl:w-[80%] sm:gap-[30px] xl:gap-[50px] flex flex-col  justify-between items-center sm:items-start sm:px-[0px]'>
                    <div className='flex flex-col h-full w-full gap-[10px]'>
                        {formData.lottery === true && 
                          <div className='flex flex-col items-center'>
                              <div className='relative'>
                                <img 
                                  src="/images/lotteryWheel.png" 
                                  alt="wheel" 
                                  id='wheel' 
                                  className={`
                                    ${isSpinning ? 'animate-spin-slow' : ''}
                                    ${isBlurred ? 'blur-lg' : ''}
                                    transition-all duration-300
                                    py-4
                                  `}
                                />
                                {showMessage && 
                                  <p className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center font-bold bg-white rounded-lg p-1'>Click on Submit to view the result</p>
                                }
                              </div>

                              {!showMessage && 
                                <button onClick={() => {
                                  setErrors({...errors, lottery: ''})
                                  spinTheWheel()
                                } 
                                } 
                                className='mt-2 w-[80px] bg-red-500 text-xl rounded-md text-white'>SPIN</button>
                              }
                          </div>
                        }
                        {errors.lottery && (
                              <span className='text-[14px] text-center text-red-500 font-bold relative top-[-8px]'>
                                  {errors.lottery}
                              </span>
                              )}
                              
                        <button
                            onClick={handleSubmit}
                            className={`px-4 py-2 rounded-3xl font-bold ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[var(--color-primary-purple)]'} w-[150px] sm:w-[200px] self-center text-white uppercase mb-4 mt-6`}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
    
    </div>
  )
}

export default QRSignupFormRaffle